import { render, staticRenderFns } from "./ProjectAssignment.vue?vue&type=template&id=27429ea4&"
import script from "./ProjectAssignment.vue?vue&type=script&lang=js&"
export * from "./ProjectAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports